module.exports = __webpack_public_path__ + "assets/a-19guaizhang.bbf8612d.svg";